import {
  StylingLook,
  StylingLookProductWithStockPrice,
  StylingLookVariantWithStockPrice,
  StylingLookWithStockPrice,
} from "../../types/productTypes/stylingLookProduct";
import { StockPriceProduct } from "../../types/productTypes/stockProduct";

export const mergeStylingLooksWithStockPrice = (
  looks: StylingLook[],
  stockPriceData: StockPriceProduct[]
): StylingLookWithStockPrice[] => {
  return looks.map((look) => {
    const updatedProducts = look.products.map((product) => {
      const stockData = stockPriceData.find(
        (sp) => sp.productId === product.id
      );
      if (!stockData) return product;

      const updatedVariants = product.variants?.map((productVariant) => {
        const stockVariant = stockData.variants?.find(
          (sv) => sv.id === productVariant.variantId
        );
        if (!stockVariant) return productVariant;

        return {
          ...productVariant,
          ...stockVariant,
        };
      });

      return {
        ...product,
        ...stockData,
        variants: updatedVariants as StylingLookVariantWithStockPrice[],
      };
    });

    return {
      ...look,
      products: updatedProducts as StylingLookProductWithStockPrice[],
    };
  });
};
